<app-content-module>
  <ul class="list">
    <li class="list__item" *ngFor="let spec of offer?.summary_specs">
      <i class="fa-regular fa-circle-check"></i>
      <p>{{ spec }}</p>
    </li>
  </ul>
</app-content-module>
